var map = {
	"./anonymous.svg": "./src/assets/icons/anonymous.svg",
	"./audio.svg": "./src/assets/icons/audio.svg",
	"./button-play.svg": "./src/assets/icons/button-play.svg",
	"./calendar.svg": "./src/assets/icons/calendar.svg",
	"./caret-right.svg": "./src/assets/icons/caret-right.svg",
	"./checkbox.svg": "./src/assets/icons/checkbox.svg",
	"./cog.svg": "./src/assets/icons/cog.svg",
	"./crown.svg": "./src/assets/icons/crown.svg",
	"./cup.svg": "./src/assets/icons/cup.svg",
	"./ear.svg": "./src/assets/icons/ear.svg",
	"./expand-regular.svg": "./src/assets/icons/expand-regular.svg",
	"./game-on.svg": "./src/assets/icons/game-on.svg",
	"./google.svg": "./src/assets/icons/google.svg",
	"./hourglass-end.svg": "./src/assets/icons/hourglass-end.svg",
	"./lobby.svg": "./src/assets/icons/lobby.svg",
	"./missions/buzz-in.svg": "./src/assets/icons/missions/buzz-in.svg",
	"./missions/categories.svg": "./src/assets/icons/missions/categories.svg",
	"./missions/draw.svg": "./src/assets/icons/missions/draw.svg",
	"./missions/fact-match.svg": "./src/assets/icons/missions/fact-match.svg",
	"./missions/freeform.svg": "./src/assets/icons/missions/freeform.svg",
	"./missions/giphy.svg": "./src/assets/icons/missions/giphy.svg",
	"./missions/info.svg": "./src/assets/icons/missions/info.svg",
	"./missions/link.svg": "./src/assets/icons/missions/link.svg",
	"./missions/lipdub.svg": "./src/assets/icons/missions/lipdub.svg",
	"./missions/multiple-choice.svg": "./src/assets/icons/missions/multiple-choice.svg",
	"./missions/photo.svg": "./src/assets/icons/missions/photo.svg",
	"./missions/pictionary.svg": "./src/assets/icons/missions/pictionary.svg",
	"./missions/player-rating.svg": "./src/assets/icons/missions/player-rating.svg",
	"./missions/poll.svg": "./src/assets/icons/missions/poll.svg",
	"./missions/take-photo.svg": "./src/assets/icons/missions/take-photo.svg",
	"./missions/team-name.svg": "./src/assets/icons/missions/team-name.svg",
	"./missions/text.svg": "./src/assets/icons/missions/text.svg",
	"./mute.svg": "./src/assets/icons/mute.svg",
	"./next-scribe.svg": "./src/assets/icons/next-scribe.svg",
	"./picture.svg": "./src/assets/icons/picture.svg",
	"./play.svg": "./src/assets/icons/play.svg",
	"./points.svg": "./src/assets/icons/points.svg",
	"./record.svg": "./src/assets/icons/record.svg",
	"./screenshot.svg": "./src/assets/icons/screenshot.svg",
	"./scribe.svg": "./src/assets/icons/scribe.svg",
	"./sidebar-divider.svg": "./src/assets/icons/sidebar-divider.svg",
	"./sync-alt.svg": "./src/assets/icons/sync-alt.svg",
	"./tip-jar.svg": "./src/assets/icons/tip-jar.svg",
	"./trophy.svg": "./src/assets/icons/trophy.svg",
	"./undo-alt.svg": "./src/assets/icons/undo-alt.svg",
	"./video.svg": "./src/assets/icons/video.svg"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/assets/icons sync recursive ^\\.\\/.*\\.svg$";